import { Flex, Text } from '@cad-arc';
import { Control, FieldValues, Path } from 'react-hook-form';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { FormCheckbox } from '../../forms/integrated-form-controls/form-checkbox';
import { FormRadioGroup } from '../../forms/integrated-form-controls/form-radio-group';

type CopyOptionsFields = {
    copyAllInformation: boolean;
    copyAttachments: boolean;
    useCurrentDateTime: 'true' | 'false';
};

interface CopyOptionsFormProps<T extends CopyOptionsFields> {
    control: Control<T>;
}

export function CopyOptionsForm<T extends FieldValues & CopyOptionsFields>({
    control,
}: CopyOptionsFormProps<T>): JSX.Element {
    const enabledFeatures = useEnabledFeatures();

    return (
        <Flex direction="column" gap={4} p={4} bg="surface.accent" borderRadius="md">
            <Flex direction="column">
                <FormCheckbox
                    name={'copyAllInformation' as Path<T>}
                    label="Copy Information"
                    control={control}
                    overrideFormSize
                    checkboxProps={{
                        size: 'md',
                    }}
                />
                <Text variant="caption">
                    Initial Narrative, Reporting Parties, Vehicles
                    {enabledFeatures.involvedPropertyEnabled ? ', Involved Properties' : ''}
                </Text>
            </Flex>
            <FormCheckbox
                name={'copyAttachments' as Path<T>}
                label="Copy Attachments"
                control={control}
                overrideFormSize
                checkboxProps={{
                    size: 'md',
                }}
            />
            <FormRadioGroup
                name={'useCurrentDateTime' as Path<T>}
                control={control}
                label="Date & Time"
                overrideFormSize
                radioGroupProps={{
                    size: 'md',
                }}
                items={[
                    { value: 'true', label: 'Current' },
                    { value: 'false', label: 'Original' },
                ]}
            />
        </Flex>
    );
}
